var _style, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJacoLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FADE63;}\r\n\t.st1{fill:#FF7D05;}\r\n\t.st2{fill:#8628FE;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#acb5b9;}\r\n\t.st5{fill:#DBD9D9;}\r\n\t.st6{fill:#BCBCBC;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 490.72,
    cy: 500,
    r: 352.34
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M660.04,506.28v92.09c0,0,0,72.14-66.89,72.14h-74.76V506.28H660.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M518.38,270.47v250.52h219.04V349.16c0,0,9.84-78.7-91.81-78.7H518.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M333.39,270.47c-101.65,0-89.13,95.75-89.13,95.75l2.57,222.18c-0.66,82.11,74.76,84.57,74.76,84.57 l83.94,2.68l6.56,53.89l108.86-59.02V270.47H333.39z M371.35,458.03c-33.25,0-60.2-26.95-60.2-60.2c0-33.25,26.95-60.2,60.2-60.2 s60.2,26.95,60.2,60.2C431.54,431.08,404.59,458.03,371.35,458.03z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJacoLive);
export default __webpack_public_path__ + "static/media/jacoLive.b4926722ef953bd0c4f88c3b203c1e58.svg";
export { ForwardRef as ReactComponent };